import Http from "../../http/client";

export default async (userId) => {
  const response = await Http.get('admin/driver/status/'+ userId);
  return response.data;
}
